module.exports = __webpack_public_path__ + "static/media/grants_thumb.4d19b690.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/projects/grants_thumb.png
// module id = 173
// module chunks = 0